import React from 'react';
import { Steps, StepsProps } from 'antd';
import styled from 'styled-components';
import { usePlanogramAutomationContext } from '../../context/PlanogramAutomation';

interface StepsComponentProps extends StepsProps {
    hideProducts?: boolean;
}

export const StepsComponent = ({
    hideProducts = false,
    ...props
}: StepsComponentProps) => {
    const { currentStep } = usePlanogramAutomationContext();

    const items = hideProducts
        ? [{ title: 'Ajustes' }, { title: 'Revisão' }]
        : [
              { title: 'Produtos' },
              { title: 'Ajustes' },
              { title: 'Revisão' },
          ];

    return (
        <StyledSteps
            {...props}
            items={items}
            current={hideProducts ? currentStep - 1 : currentStep}
        />
    );
};

export const StyledSteps = styled(Steps)`
    width: 63%;
    padding: 24px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;
